import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { IStyles } from 'libs/shared-ui/src/commonUtils/styleUtils';
import { pxToRem } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react';
import {
  getLocalStorage,
  getDifficultyLevelString,
  cloneObject,
  IconWrapper,
  ImageWrapper,
  InputField,
  PrimaryButton,
  theme,
  useCommonServiceClientContext,
  Loader,
  ActionPopUpSingleButton,
} from '@geneo2-web/shared-ui';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  useAppDispatch,
  useAppSelector,
  useDeserifiedSelector,
} from 'apps/teacher/src/reduxStore/reduxHooks';
import { useGlobalContext } from 'apps/teacher/src/app/Context/GlobalContextProvider';
import {
  ASSESMENT_LIBRARY,
  FA_ASSIGN_SETTINGS,
  FA_CREATION,
  FA_DRAFT,
  FA_PREVIEW,
  FA_REVIEW,
  HOMEWORK_MANAGE,
} from '../../../../routeHandling/RoutesNomenclature';
import {
  setAssessmentLibraryFilter,
  setFAAllChaptersData,
  setFAContent,
  setFACreatedSectionTest,
  setFaFormatDetails,
  setFALibraryChoiceCreation,
  setFASelectedChapters,
  setFASelectedSectionNumber,
  setFASettingsConfig,
  setSelectedChapter,
  setSelectedTopic,
} from '../../reducer/assessmentFlow.slice';
import { InstructionPopup } from '../../QuestionPaperGeneratorV2/QPGPublish/components/InstructionPopup';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import { PaperDetailsCard } from '../../QuestionPaperGeneratorV2/components/PaperDetailsCard';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { getSubjectNameFromEnum } from '../../../Home/home.utils';
import { FASelectMultiSubjectsPopup } from '../FASelectMultiSubjectsPopup/FASelectMultiSubjectsPopup';
import {
  buildTaskInfoModels,
  getSubjectColorBySubjectId,
  getSubjectImageBySubjectId,
  getTotalMarksOfSection,
} from '../../utils/QPGv2.utils';
import {
  AssessmentEnum,
  ModeOfConductionEnum,
  MultiSubjectSection,
  MultiSubjectSectionStatusEnum,
  MarkingSchemeEnum,
  TaskCreationStatusEnum,
  TaskEnum,
  QuestionModuleMap,
} from '@protos/learning_management/lms.db_pb';
import { DifficultyLevelEnum } from '@protos/content_management/content.db_pb';
import {
  SubSectionQuestionType,
  SubSectionType,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { QPG_ASSESSMENT_REVIEW_PAPER } from '../../../../routeHandling/RoutesNomenclature';
import {
  setClassAndSubjectInfo,
  setToastInfoV2,
} from '../../../Home/reducer/homeDashboard.slice';
import { getMediaBasePath } from 'libs/shared-ui/src/commonUtils/images';
import {
  AssessmentContent,
  AssessmentTask,
} from '@protos/learning_management/lms.assessment.common.apis_pb';
import { ConnectError } from '@bufbuild/connect';
import {
  CourseIndexInfo,
  SubjectChapterMiniInfo,
  TopicBasicInfo,
} from '@protos/content_management/content.common.apis_pb';
import { ValidationPopup } from '../../QuestionPaperGenerator/QuestionPaperCreate/components/ValidationPopup';
import { EditWarningPopup } from 'apps/teacher/src/components/EditWarningPopup';
import {
  getLatestQuestionModuleMap,
  getQuestionIdsFromMultiSubjectSection,
  getRepeatingQuestionIdsForLibraryAssessment,
  getRepeatingQuestionIdsForLibrarySection,
  getUpdatedChapterInfo,
  getSectionFromAssessmentContent,
  getSectionWithFilteredQuestionIds,
  getSectionWithMaxQuestionCount,
  applyMarksToAllQuestions,
} from '../FAv2.utils';
import {
  getOmrRemainingQuestionSlotsForSection,
  getSectionQuestionCount,
  getTotalAssessmentQuestionCount,
  isOmrQuestionLimitReached,
  OMR_MAX_QUESTIONS_LIMIT_MESSAGE,
} from '../../utils/assessment.utils';

const styles: IStyles = {
  root: {
    paddingX: { xs: pxToRem(20), md: pxTovW(50), lg: pxTovW(240) },
    paddingTop: { xs: pxToRem(20), md: pxTovW(50) },
    paddingBottom: { xs: pxToRem(70), md: pxTovW(50) },
    backgroundColor: '#f8f7fc',
    minHeight: '100vh',
    position: { xs: 'relative', md: 'unset' },
  },
  mainHeadingBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: { xs: pxToRem(20), md: pxTovW(30) },
    gap: { xs: pxToRem(10), md: pxTovW(50) },
  },
  assessNameBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    boxSizing: 'border-box',
  },
  ellipsisText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word',
    paddingBottom: { xs: pxToRem(5), md: pxTovW(5) },
  },
  sectionTitleInput: {
    maxWidth: '100%',
    boxSizing: 'border-box',
    '& input': {
      maxWidth: '100%',
      width: '100%',
      height: { xs: pxToRem(25), md: pxTovW(54) },
      fontFamily: 'Poppins',
      fontSize: { xs: pxToRem(18), md: pxTovW(40) },
    },
    '& .MuiOutlinedInput-root': {
      padding: '0',
      borderBottom: `2px solid #007CDC`,
      backgroundColor: 'transparent',
      paddingX: { xs: pxToRem(10), md: pxTovW(10) },
      borderRadius: '0',
    },
  },
  previewAndCreateBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
  },
  previewAndAddMoreBox: {
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(20) },
    width: { xs: '100%', md: 'unset' },
    alignItems: 'center',
  },
  previewButton: {
    backgroundColor: '#FFF6D4',
    border: '2px solid #F8C807',
    borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
    cursor: 'pointer',
    boxSizing: 'border-box',
    width: { xs: pxToRem(28), md: pxTovW(60), lg: pxTovW(47) },
    height: { xs: pxToRem(28), md: pxTovW(60), lg: pxTovW(47) },
    display: { xs: 'none', md: 'flex' },
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  editIcon: {
    height: { xs: pxToRem(21), md: pxTovW(30) },
    width: { xs: pxToRem(21), md: pxTovW(30) },
    border: '1px solid #0AA34F',
    borderRadius: { xs: pxToRem(6), md: pxTovW(6) },
  },
  saveToLibraryButton: {
    width: { xs: '40%', md: pxTovW(320) },
    // height: { xs: pxToRem(55), md: pxTovW(77) },
    paddingY: { xs: pxToRem(5), md: pxTovW(10) },
    paddingX: { xs: pxToRem(5), md: 'unset' },
    backgroundColor: 'primary.main',
  },
  createButton: {
    width: { xs: '90%', md: pxTovW(320) },
    // height: { xs: pxToRem(55), md: pxTovW(77) },
    paddingY: { xs: pxToRem(10), md: pxTovW(10) },
    position: { xs: 'fixed', md: 'unset' },
    bottom: { xs: pxToRem(5), md: 'unset' },
    left: { xs: '5%', md: 'unset' },
    zIndex: { xs: 10, md: 0 },
  },
  classNameAddMoreBox: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', md: 'center' },
    marginBottom: { xs: pxToRem(20), md: pxTovW(30) },
    gap: { xs: pxToRem(25), md: pxTovW(0) },
  },
  secondaryHeadingBox: {
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(25) },
    alignItems: 'center',
  },
  classNamePill: {
    border: '1px solid #5DACF7',
    backgroundColor: '#DDFAEC',
    borderRadius: { xs: pxToRem(25), md: pxTovW(25) },
    paddingX: { xs: pxToRem(10), md: pxTovW(25) },
    paddingY: { xs: pxToRem(5), md: pxTovW(10) },
  },
  addInstructionsBox: {
    background: '#CFEAFF',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #007CDC',
    padding: {
      xs: pxToRem(5),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
    height: { xs: pxToRem(28), md: pxTovW(57) },
  },
  addMoreBox: {
    background: '#C1F8DA',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #0AA34F',
    padding: {
      xs: pxToRem(5),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
    height: { xs: pxToRem(28), md: pxTovW(57) },
  },
};

export const FADraft = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const teacherId = getLocalStorage('userId');
  const [searchParams] = useSearchParams();
  const assessmentId = searchParams.get('assessment_id');
  const { setSelectedFunction } = useGlobalContext();
  const {
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const user_info = useDeserifiedSelector(
    (state) => state.auth.user_info
  );
  const class_subject_info = useDeserifiedSelector(
    (state) => state.homeDashboard.class_subject_info
  );
  const fa_format_details = useDeserifiedSelector(
    (state) => state.assessment.fa_format_details
  );
  const fa_content = useDeserifiedSelector(
    (state) => state.assessment.fa_content
  );
  const fa_library_choice_creation = useDeserifiedSelector(
    (state) => state.assessment.fa_library_choice_creation
  );

  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );
  const [faNameEdit, setFaNameEdit] = useState<boolean>(false);
  const [addInstructionsPopup, setAddInstructionsPopup] =
    useState<boolean>(false);
  const [instructions, setInstructions] = useState<string>('');
  const [multiSubjectsPopup, setMultiSubjectsPopup] = useState<boolean>(false);
  const [saveToLibraryPopup, setSaveToLibraryPopup] = useState<boolean>(false);
  const [deleteSectionIndex, setDeleteSectionIndex] = useState<
    number | undefined
  >(undefined);
  const [libraryDuplicateWarningPopup, setLibraryDuplicateWarningPopup] =
    useState<boolean>(false);
  const [libraryAllDuplicateWarningPopup, setLibraryAllDuplicateWarningPopup] =
    useState<boolean>(false);
  const [libraryDuplicateQuestionIds, setLibraryDuplicateQuestionIds] =
    useState<string[]>([]);
  const [libraryImportPayload, setLibraryImportPayload] = useState<{
    fetchedAssessmentContent: AssessmentContent;
    librarySection?: MultiSubjectSection;
  }>();
  const [omrQuestionLimitPopupOpen, setOmrQuestionLimitPopupOpen] =
    useState(false);

  // ----------------------------------------------------

  const showOmrQuestionLimitPopupIfReached = (): boolean => {
    if (
      isOmrQuestionLimitReached(
        fa_content?.assessment?.modeOfConduction,
        getTotalAssessmentQuestionCount(fa_content?.multiSubjectSections)
      )
    ) {
      setOmrQuestionLimitPopupOpen(true);
      return true;
    }
    return false;
  };

  // ----------------------------------------------------

  const showOmrQuestionLimitPopup = () => {
    setOmrQuestionLimitPopupOpen(true);
  };

  // ----------------------------------------------------

  const applyOmrLimitToImportedSection = (
    section: MultiSubjectSection
  ): MultiSubjectSection | null => {
    if (
      fa_content?.assessment?.modeOfConduction !==
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR ||
      fa_library_choice_creation?.section_number == null
    ) {
      return section;
    }

    const maxForSection = getOmrRemainingQuestionSlotsForSection({
      multiSubjectSections: fa_content.multiSubjectSections,
      currentSectionNo: fa_library_choice_creation.section_number,
    });

    if (maxForSection <= 0) {
      return null;
    }

    if (getSectionQuestionCount(section) > maxForSection) {
      return getSectionWithMaxQuestionCount(section, maxForSection);
    }

    return section;
  };

  // ----------------------------------------------------

  const isCreateNewSectionFlow = (item: MultiSubjectSection) =>
    item.multiSubjectSectionStatus ===
      MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_UNDEFINED ||
    item.multiSubjectSectionStatus ===
      MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED;

  // ----------------------------------------------------

  const previewAssessment = () => {
    navigate(FA_PREVIEW);
  };

  // ----------------------------------------------------

  const createButtonDisabled = useMemo(() => {
    return fa_content?.multiSubjectSections.some(
      (section) =>
        section.multiSubjectSectionStatus !==
        MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_APPROVED
    );
  }, [fa_content]);

  // ----------------------------------------------------

  const openMultiSubjectsPopup = () => {
    if (fa_content) {
      const selectedSubjects =
        fa_content.multiSubjectSections?.map((item) => ({
          name:
            item.subject != null ? getSubjectNameFromEnum(item.subject) : '',
          id: item.subjectId ?? 0,
        })) ?? [];
      dispatch(
        setFaFormatDetails({
          ...fa_format_details,
          ...(fa_content.assessment?.classId != null && {
            selectedClass: {
              name: `Class ${fa_content.assessment?.class}`,
              id: fa_content.assessment.classId,
            },
          }),
          selectedSubjects:
            selectedSubjects.length > 0
              ? selectedSubjects
              : [{ name: '', id: 0 }],
          assessmentName: fa_content.assessment?.assessmentTitle ?? '',
        })
      );
    }
    setMultiSubjectsPopup(true);
  };

  // ----------------------------------------------------

  const handleCreateFA = async (props: {
    createClickType?: 'create' | 'saveToLibrary';
    updatedContent?: AssessmentContent;
    chooseLibraryQuestionModuleMap?: QuestionModuleMap[];
  }) => {
    const { createClickType, updatedContent, chooseLibraryQuestionModuleMap } =
      props;

    let metaInfo: MultiSubjectSection[] = [];
    if (updatedContent) {
      metaInfo = updatedContent?.multiSubjectSections?.map(
        (section: MultiSubjectSection) =>
          new MultiSubjectSection({
            ...section,
            // if no status is then: INITIALIZED
            multiSubjectSectionStatus: section.multiSubjectSectionStatus
              ? section.multiSubjectSectionStatus
              : MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED,
            sectionNo: section.sectionNo,
          })
      );
    } else {
      metaInfo = fa_content?.multiSubjectSections ?? [];
    }

    const selectedTasksInfo = buildTaskInfoModels(metaInfo);

    // const filteredQuestionModuleMap = getLatestQuestionModuleMap({
    //   metaInfo: metaInfo,
    //   questionModuleMap: fa_content?.questionsSequenceInfo?.questionModuleMap,
    // });

    const selectedQuestionIds = new Set(
      selectedTasksInfo
        .map((taskInfo) => taskInfo.questionId)
        .filter((questionId): questionId is string => Boolean(questionId))
    );

    const filteredQuestionModuleMap = [
      ...(fa_content?.questionsSequenceInfo?.questionModuleMap ?? []),
      ...(chooseLibraryQuestionModuleMap ?? []),
    ].filter((questionModule) =>
      selectedQuestionIds.has(questionModule.questionId)
    );

    try {
      setLoading('loading');
      const assessmentCreationSubmitResponse =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            teacherId: BigInt(teacherId),
            assessmentId: (assessmentId ? BigInt(assessmentId) : undefined),
            classId: fa_content?.assessment?.classId,
            creationStatus: createClickType
              ? TaskCreationStatusEnum.TASK_CREATION_STATUS_APPROVED
              : TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
            multiSubjectSectionMetaInfo: metaInfo,
            // sectionId: class_subject_info?.sectionId,
            subjectIds: metaInfo?.map((section) => section.subjectId) ?? [],
            taskName: fa_content?.assessment?.assessmentTitle ?? '',
            taskType: TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM,
            instructions: [instructions],
            questionModuleMap: filteredQuestionModuleMap,
            selectedTasksInfo: selectedTasksInfo,
            markingSchemeType: fa_content?.assessment?.markingSchemeType,
            marksPerQuestion:
              fa_content?.questionsSequenceInfo?.marksPerQuestion,
            // chapterIdsInfo:
            //   fa_content?.assessment?.taskMetaInfo?.chapterInfo
            //     ?.chapterTopicsInfo,
          }
        );

      if (assessmentCreationSubmitResponse.status === 200) {
        if (createClickType === 'create') {
          navigate(FA_ASSIGN_SETTINGS + `?assessment_id=${assessmentId}`);
        } else if (createClickType === 'saveToLibrary') {
          setSaveToLibraryPopup(true);
        } else {
          await fetchAssessmentContent();
        }
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Error while creating assessment',
            variant: 'error',
            open: true,
          })
        );
      }
      setLoading('success');
    } catch (error) {
      setLoading('success');
      console.log('error:', error);
      let message = 'Error while creating assessment';
      if (error instanceof ConnectError) {
        message = error.rawMessage?.replace(/.*\]\s*/, '').trim();
      }
      dispatch(
        setToastInfoV2({
          label: message,
          variant: 'error',
          open: true,
        })
      );
    }
  };

  // ----------------------------------------------------

  const onDragEnd = useCallback(
    (result: DropResult) => {
      if (!result.destination || !fa_content) return;
      const { source, destination } = result;
      if (source.index === destination.index) return;
      const sections = [...fa_content.multiSubjectSections];
      const [removed] = sections.splice(source.index, 1);
      sections.splice(destination.index, 0, removed);
      // Update sectionNo to match new order (1-based)
      const sectionsWithUpdatedSectionNo = sections.map(
        (section: MultiSubjectSection, index: number) => {
          const cloned = cloneObject(section);
          cloned.sectionNo = index + 1;
          return cloned;
        }
      );
      const updatedContent = cloneObject(fa_content);
      updatedContent.multiSubjectSections = sectionsWithUpdatedSectionNo;
      dispatch(setFAContent(updatedContent));
      handleCreateFA({ updatedContent: updatedContent });
    },

    [dispatch, fa_content]
  );

  // ----------------------------------------------------

  const fetchAssessmentContent = async () => {
    if (!assessmentId) return;

    try {
      setLoading('loading');
      const fetchAssessmentContentResponse =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacherId,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: (assessmentId ? BigInt(assessmentId) : undefined),
          }
        );

      if (fetchAssessmentContentResponse.data) {
        setLoading('success');

        dispatch(setFAContent(fetchAssessmentContentResponse.data));
        setInstructions(
          fetchAssessmentContentResponse.data?.assessment
            ?.assessmentInstructions[0] || ''
        );

        const data = fetchAssessmentContentResponse.data;
        const selectedSubjects =
          data?.multiSubjectSections?.map((item) => ({
            name:
              item.subject != null ? getSubjectNameFromEnum(item.subject) : '',
            id: item.subjectId ?? 0,
          })) ?? [];

        dispatch(
          setFaFormatDetails({
            ...fa_format_details,
            ...(data?.assessment?.classId != null && {
              selectedClass: {
                name: `Class ${data?.assessment?.class}`,
                id: data.assessment.classId,
              },
            }),
            selectedSubjects:
              selectedSubjects.length > 0
                ? selectedSubjects
                : [{ name: '', id: 0 }],
            assessmentName: data?.assessment?.assessmentTitle ?? '',
          })
        );
      } else {
        setLoading('error');
      }
    } catch (error) {
      console.log(error);
      setLoading('error');
    }
  };

  // ----------------------------------------------------

  const getTotalQuestionNumber = (sectionIndex: number) => {
    return (
      fa_content?.multiSubjectSections?.[
        sectionIndex
      ]?.multiSubjectSubSections?.reduce(
        (acc, curr) => acc + (curr.subSectionMetaData?.length ?? 0),
        0
      ) ?? 0
    );
  };

  // ----------------------------------------------------

  const changeSectionTitle = (sectionIndex: number, title: string) => {
    if (!fa_content?.multiSubjectSections?.length) return;
    if (
      sectionIndex < 0 ||
      sectionIndex >= fa_content.multiSubjectSections.length
    )
      return;
    const updatedContent = cloneObject(fa_content);
    updatedContent.multiSubjectSections = fa_content.multiSubjectSections.map(
      (section, i) =>
        i === sectionIndex
          ? new MultiSubjectSection({ ...section, sectionTitle: title })
          : section
    );
    dispatch(setFAContent(updatedContent));
  };

  // ----------------------------------------------------

  const handleDeleteCard = useCallback(
    (index: number) => {
      if (!fa_content) return;
      if ((fa_content.multiSubjectSections?.length ?? 0) <= 1) {
        dispatch(
          setToastInfoV2({
            label: 'At least one item should be in the assessment.',
            variant: 'info',
            open: true,
          })
        );
        return;
      }
      const updatedContent = cloneObject(fa_content);
      const sectionsAfterDelete =
        fa_content.multiSubjectSections?.filter((_, i) => i !== index) ?? [];
      // Update sectionNo to keep them sequential (1-based) after deletion
      updatedContent.multiSubjectSections = sectionsAfterDelete.map(
        (section: MultiSubjectSection, idx: number) => {
          const cloned = cloneObject(section);
          cloned.sectionNo = idx + 1;
          return cloned;
        }
      );
      dispatch(setFAContent(updatedContent));
      handleCreateFA({ updatedContent: updatedContent });
    },
    [dispatch, fa_content]
  );

  // ----------------------------------------------------

  const createFlowStarter = (item: MultiSubjectSection) => {
    if (isCreateNewSectionFlow(item) && showOmrQuestionLimitPopupIfReached()) {
      return;
    }

    dispatch(setFASelectedSectionNumber(item.sectionNo));

    const sectionChapterInfo = item?.chapterInfo?.chapterTopicsInfo;
    const chaptersFromSection = sectionChapterInfo?.map(
      (ch) =>
        new SubjectChapterMiniInfo({
          chapterId: ch.chapterId,
          chapterNo: ch.chapterNo,
          chapterTitle: ch.name,
          posterImagesUrl: '',
          noOfTopics: ch.topicInfo?.length ?? 0,
          topics: (ch.topicInfo ?? []).map(
            (t) =>
              new TopicBasicInfo({
                topicId: t.topicId,
                topicNo: t.topicNo,
                topicTitle: t.name,
                posterImagesUrl: '',
              })
          ),
        })
    );
    dispatch(
      setFASelectedChapters(
        new CourseIndexInfo({
          subjectId: item.subjectId,
          subjectName: '',
          posterImageUrl: '',
          chapters: chaptersFromSection,
        })
      )
    );

    if (isCreateNewSectionFlow(item)) {
      navigate(FA_CREATION);
    } else {
      navigate(FA_REVIEW);
    }
  };

  // ----------------------------------------------------

  // ! Choose Library
  const handleChooseLibrary = (item: MultiSubjectSection) => {
    if (
      fa_content?.assessment?.modeOfConduction ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      const remaining = getOmrRemainingQuestionSlotsForSection({
        multiSubjectSections: fa_content?.multiSubjectSections,
        currentSectionNo: item.sectionNo,
      });
      if (remaining <= 0) {
        showOmrQuestionLimitPopup();
        return;
      }
    }

    dispatch(
      setAssessmentLibraryFilter({
        assessmentType: {
          name: 'Formative',
          id: AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT,
        },
        CreatedBy: undefined,
      })
    );
    dispatch(setSelectedChapter(undefined));
    dispatch(setSelectedTopic(undefined));
    dispatch(
      setFALibraryChoiceCreation({
        section_number: item.sectionNo,
        subject_id: item.subjectId,
        marking_scheme: item.markingSchemeType,
        conduction_mode: fa_content?.assessment?.modeOfConduction,
      })
    );

    for (const classInfo of user_info?.teachClassSubjects ?? []) {
      const matchedSubject = classInfo.subjects?.find(
        (s) => s.subjectId === item.subjectId
      );
      if (matchedSubject) {
        dispatch(
          setClassAndSubjectInfo({
            classname: classInfo.className,
            section: classInfo.sectionName,
            sectionId: classInfo.sectionId,
            subjectId: matchedSubject.subjectId,
            subject: matchedSubject.subjectName,
            icon: matchedSubject.iconUrl
              ? getMediaBasePath(
                  matchedSubject.iconUrl,
                  'schoolnetStaticAssetBucket'
                )
              : '',
            color: matchedSubject.textColor,
            bookId: matchedSubject.bookId,
            classId: classInfo.classId,
            isClickerSupported: !!classInfo.isClickerSupported,
          })
        );
        break;
      }
    }

    navigate(ASSESMENT_LIBRARY, {
      state: {
        redirectionPath: `${FA_DRAFT}?assessment_id=${assessmentId}`,
        chooseFromLibrary: true,
      },
    });
  };

  // ----------------------------------------------------

  /**
   * Runs when user returns from library with a chosen assessment.
   * Detects duplicate questions and decides whether to proceed directly,
   * ask for partial-duplicate confirmation, or block all-duplicate imports.
   */
  const checkForLibraryChoiceCreation = async () => {
    try {
      setLoading('loading');
      const fetchAssessmentContentResponse =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacherId,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: fa_library_choice_creation?.chosen_assessment?.assessmentId,
            markingSchemeType: fa_library_choice_creation?.marking_scheme,
            modeOfConduction: fa_content?.assessment?.modeOfConduction,
          }
        );

      if (fetchAssessmentContentResponse.data) {
        const resData = fetchAssessmentContentResponse.data;

        if (
          !fa_content?.multiSubjectSections?.length ||
          fa_library_choice_creation?.section_number == null
        ) {
          return;
        }

        const librarySection =
          resData?.multiSubjectSections?.find((s) =>
            fa_library_choice_creation?.subject_id != null
              ? s.subjectId === fa_library_choice_creation.subject_id
              : true
          ) ?? resData?.multiSubjectSections?.[0];

        const repeatedQuestionIds = librarySection
          ? getRepeatingQuestionIdsForLibrarySection({
              faContent: fa_content,
              sectionNumberToReplace: fa_library_choice_creation.section_number,
              librarySection,
            })
          : getRepeatingQuestionIdsForLibraryAssessment({
              faContent: fa_content,
              sectionNumberToReplace: fa_library_choice_creation.section_number,
              libraryAssessmentContent: resData,
            });

        const totalIncomingQuestionIds = librarySection
          ? getQuestionIdsFromMultiSubjectSection(librarySection)
          : Array.from(
              new Set(
                (resData.assessmentContent ?? [])
                  .map((q) => q.questionId)
                  .filter((id): id is string => !!id)
              )
            );

        if (repeatedQuestionIds.length > 0) {
          setLoading('success');
          if (
            totalIncomingQuestionIds.length > 0 &&
            repeatedQuestionIds.length === totalIncomingQuestionIds.length
          ) {
            setLibraryAllDuplicateWarningPopup(true);
          } else {
            setLibraryDuplicateQuestionIds(repeatedQuestionIds);
            setLibraryImportPayload({
              fetchedAssessmentContent: resData,
              librarySection,
            });
            setLibraryDuplicateWarningPopup(true);
          }
          return;
        }

        await proceedLibraryChoiceCreation({
          fetchedAssessmentContent: resData,
          librarySection,
          duplicateQuestionIds: [],
        });
      } else {
        setLoading('error');
      }
    } catch (error) {
      console.log(error);
      setLoading('error');
    } finally {
      setLoading('success');
    }
  };

  // ----------------------------------------------------

  /**
   * Applies the selected library content to the target section and persists it.
   * Any duplicate question IDs provided here are removed before section replacement.
   */
  const proceedLibraryChoiceCreation = async (props: {
    fetchedAssessmentContent: AssessmentContent;
    librarySection?: MultiSubjectSection;
    duplicateQuestionIds: string[];
  }) => {
    const { fetchedAssessmentContent, librarySection, duplicateQuestionIds } =
      props;
    try {
      if (
        !fa_content?.multiSubjectSections?.length ||
        fa_library_choice_creation?.section_number == null
      ) {
        dispatch(setFALibraryChoiceCreation(undefined));
        return;
      }

      const updatedContent = cloneObject(fa_content);
      if (librarySection) {
        const filteredLibrarySection = getSectionWithFilteredQuestionIds({
          section: librarySection,
          questionIdsToRemove: duplicateQuestionIds,
          markingScheme: fa_library_choice_creation?.marking_scheme,
        });
        const omrLimitedSection = applyOmrLimitToImportedSection(
          filteredLibrarySection
        );
        if (!omrLimitedSection) {
          showOmrQuestionLimitPopup();
          dispatch(setFALibraryChoiceCreation(undefined));
          return;
        }
        updatedContent.multiSubjectSections =
          updatedContent.multiSubjectSections.map(
            (section: MultiSubjectSection) =>
              section.sectionNo === fa_library_choice_creation.section_number
                ? new MultiSubjectSection({
                    ...cloneObject(omrLimitedSection),
                    // Ensure ordering/section numbering matches the draft.
                    sectionNo: fa_library_choice_creation.section_number,
                    markingSchemeType:
                      fa_library_choice_creation?.marking_scheme,
                  })
                : section
          );
      } else {
        const importedSection = getSectionFromAssessmentContent({
          assessData: fetchedAssessmentContent,
          subjectSectionNo: fa_library_choice_creation?.section_number,
          subjectCollection: user_info?.teachClassSubjects,
          questionIdsToExclude: duplicateQuestionIds,
          marking_scheme: fa_library_choice_creation?.marking_scheme,
        });
        const omrLimitedSection =
          applyOmrLimitToImportedSection(importedSection);
        if (!omrLimitedSection) {
          showOmrQuestionLimitPopup();
          dispatch(setFALibraryChoiceCreation(undefined));
          return;
        }
        updatedContent.multiSubjectSections =
          updatedContent.multiSubjectSections.map(
            (section: MultiSubjectSection) =>
              section.sectionNo === fa_library_choice_creation?.section_number
                ? omrLimitedSection
                : section
          );
      }

      // const updatedContentForCreate =
      //   fa_library_choice_creation?.marking_scheme ===
      //   MarkingSchemeEnum.MARKING_SCHEME_JEE
      //     ? applyJeeMarksToAllQuestions({ assessmentData: updatedContent })
      //     : updatedContent;
      const updatedContentForCreate = applyMarksToAllQuestions({
        assessmentData: updatedContent,
        markingScheme: fa_library_choice_creation?.marking_scheme,
        customMarks: fa_content.questionsSequenceInfo?.marksPerQuestion,
      });

      const updatedContentWithChapterInfoFix = getUpdatedChapterInfo({
        assessmentData: updatedContentForCreate,
        sectionNumber: fa_library_choice_creation?.section_number,
        questionModuleMap: fetchedAssessmentContent.questionModuleMap,
      });

      await handleCreateFA({
        updatedContent: updatedContentWithChapterInfoFix,
        chooseLibraryQuestionModuleMap:
          fetchedAssessmentContent.questionModuleMap,
      });
      dispatch(setFALibraryChoiceCreation(undefined));
    } catch (error) {
      console.log(error);
      setLoading('error');
    } finally {
      setLibraryImportPayload(undefined);
      setLibraryDuplicateQuestionIds([]);
      setLibraryDuplicateWarningPopup(false);
      setLoading('success');
    }
  };

  // ----------------------------------------------------

  /**
   * Shared abort path for duplicate popups:
   * close dialogs, clear temporary import state, and reset library choice in redux.
   */
  const handleDuplicateLibraryImportNo = () => {
    setLibraryDuplicateWarningPopup(false);
    setLibraryAllDuplicateWarningPopup(false);
    setLibraryImportPayload(undefined);
    setLibraryDuplicateQuestionIds([]);
    dispatch(setFALibraryChoiceCreation(undefined));
  };

  // ----------------------------------------------------

  /**
   * Confirmation path for partial-duplicate imports.
   * Continues import after removing duplicated questions.
   */
  const handleDuplicateLibraryImportYes = async () => {
    if (!libraryImportPayload) {
      handleDuplicateLibraryImportNo();
      return;
    }
    await proceedLibraryChoiceCreation({
      fetchedAssessmentContent: libraryImportPayload.fetchedAssessmentContent,
      librarySection: libraryImportPayload.librarySection,
      duplicateQuestionIds: libraryDuplicateQuestionIds,
    });
  };

  // ----------------------------------------------------

  const backClickHandler = () => {
    if (location.state?.fromAssessmentLibrary) {
      navigate(ASSESMENT_LIBRARY, { state: { fromFADraft: true } });
    } else {
      navigate(HOMEWORK_MANAGE);
    }
  };

  useEffect(() => {
    setSelectedFunction(() => backClickHandler);

    fetchAssessmentContent();

    dispatch(setFASelectedSectionNumber(undefined));
    dispatch(setFAAllChaptersData(undefined));
    dispatch(setFASelectedChapters(undefined));
    dispatch(setFASettingsConfig(undefined));
    dispatch(setFACreatedSectionTest(undefined));
    if (!!fa_library_choice_creation?.chosen_assessment) {
      /*
      when the user comes back from library
      and has chosen an assessment use it to populate the section
      */
      checkForLibraryChoiceCreation();
    }

    return () => {
      setSelectedFunction(null);
    };
  }, []);

  // ----------------------------------------------------

  if (loading === 'loading') return <Loader />;

  // if (loading === 'error') return <NoContentCard variant="error" icon="error" text="Error Occurred" />;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.mainHeadingBox}>
        <Box sx={styles.assessNameBox}>
          {faNameEdit ? (
            <InputField
              variant="outlined"
              fullWidth
              placeholder="Add Section Title"
              type="text"
              value={fa_content?.assessment?.assessmentTitle ?? ''}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                // setEditingAssessmentTitle(e.target.value);
                if (!fa_content) return;
                const updatedContent = cloneObject(fa_content);
                if (updatedContent.assessment) {
                  updatedContent.assessment = new AssessmentTask({
                    ...updatedContent.assessment,
                    assessmentTitle: e.target.value,
                  });
                }
                dispatch(setFAContent(updatedContent));
              }}
              onBlur={() => {
                handleCreateFA({});
                setFaNameEdit(false);
              }}
              sx={styles.sectionTitleInput}
            />
          ) : (
            <Typography variant="h1" sx={styles.ellipsisText}>
              {fa_content?.assessment?.assessmentTitle}
            </Typography>
          )}

          <Button
            onClick={() => {
              if (faNameEdit) {
                handleCreateFA({});
              }
              setFaNameEdit((prev) => !prev);
            }}
            sx={{ padding: '0' }}
          >
            <IconWrapper
              name={faNameEdit ? 'correct-green-square' : 'edit'}
              parentFolder="icons"
              type="png"
              size="md"
              customSx={styles.editIcon}
            />
          </Button>
        </Box>

        <Box sx={styles.previewAndCreateBox}>
          <Button onClick={previewAssessment} sx={styles.previewButton}>
            <ImageWrapper
              name="eye-yellow"
              parentFolder="icons"
              type="png"
              styles={{
                width: { xs: pxToRem(15), md: pxTovW(24) },
                height: { xs: pxToRem(10), md: pxTovW(18) },
              }}
            />
          </Button>

          {createButtonDisabled ? null : (
            <PrimaryButton
              variant="contained"
              onClick={() =>
                handleCreateFA({ createClickType: 'saveToLibrary' })
              }
              sx={{
                ...styles.saveToLibraryButton,
                display: { xs: 'none', md: 'block' },
              }}
            >
              <Typography variant="h3" fontWeight="bold" color="common.white">
                SAVE TO LIBRARY
              </Typography>
            </PrimaryButton>
          )}

          <PrimaryButton
            variant="contained"
            disabled={createButtonDisabled}
            onClick={() => handleCreateFA({ createClickType: 'create' })}
            sx={styles.createButton}
          >
            <Typography variant="h3" fontWeight="bold" color="common.white">
              CREATE
            </Typography>
          </PrimaryButton>
        </Box>
      </Box>

      <Box sx={styles.classNameAddMoreBox}>
        <Box sx={styles.secondaryHeadingBox}>
          <Typography variant="h2">Your Added Subjects</Typography>

          <Box sx={styles.classNamePill}>
            <Typography variant="h3" fontWeight="bold" color="primary">
              Class {fa_content?.assessment?.class}
            </Typography>
          </Box>
        </Box>

        <Box sx={styles.previewAndAddMoreBox}>
          <Button
            onClick={previewAssessment}
            sx={{
              ...styles.previewButton,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <ImageWrapper
              name="eye-yellow"
              parentFolder="icons"
              type="png"
              styles={{
                width: { xs: pxToRem(15), md: pxTovW(24) },
                height: { xs: pxToRem(10), md: pxTovW(18) },
              }}
            />
          </Button>

          {/* <Button
            sx={styles.addInstructionsBox}
            onClick={() => {
              setAddInstructionsPopup(true);
            }}
          >
            <AddCircleIcon
              sx={{
                color: 'primary.main',
                fontSize: { xs: pxToRem(18), md: pxTovW(30) },
              }}
            />
            <Typography
              variant={isMobile ? 'h4' : 'h3'}
              fontWeight="bold"
              color="primary.main"
            >
              {(fa_content?.assessment?.assessmentInstructions?.length ?? 0) >
                0 && fa_content?.assessment?.assessmentInstructions?.[0] !== ''
                ? 'EDIT INSTRUCTIONS'
                : 'ADD INSTRUCTIONS'}
            </Typography>
          </Button> */}

          <Button
            sx={styles.addMoreBox}
            onClick={() => {
              openMultiSubjectsPopup();
            }}
          >
            <AddCircleIcon
              sx={{
                color: '#03612D',
                fontSize: { xs: pxToRem(18), md: pxTovW(30) },
              }}
            />
            <Typography
              variant={isMobile ? 'h4' : 'h3'}
              fontWeight="bold"
              color="secondary.main"
            >
              ADD MORE
            </Typography>
          </Button>

          {createButtonDisabled ? null : (
            <Button
              variant="contained"
              onClick={() =>
                handleCreateFA({ createClickType: 'saveToLibrary' })
              }
              sx={{
                ...styles.saveToLibraryButton,
                display: { xs: 'block', md: 'none' },
              }}
            >
              <Typography variant="h5" fontWeight="bold" color="common.white">
                SAVE TO LIBRARY
              </Typography>
            </Button>
          )}
        </Box>
      </Box>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="paper-details-cards">
          {(droppableProvided) => (
            <Box
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: pxToRem(10), md: pxTovW(30) },
              }}
            >
              {fa_content?.multiSubjectSections?.map((item, index) => (
                <Draggable
                  key={index}
                  draggableId={index.toString()}
                  index={index}
                >
                  {(draggableProvided) => (
                    <Box
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <PaperDetailsCard
                        totalSections={
                          fa_content?.multiSubjectSections?.length ?? 0
                        }
                        subjectIcon={getSubjectImageBySubjectId(
                          item.subjectId,
                          user_info?.teachClassSubjects
                        )}
                        subjectColor={getSubjectColorBySubjectId(
                          item.subjectId,
                          user_info?.teachClassSubjects
                        )}
                        subjectName={getSubjectNameFromEnum(item.subject)}
                        marks={item.totalMarks}
                        reorderCardHandler={() => {}}
                        deleteCardHandler={() => {
                          if (
                            item.multiSubjectSectionStatus ===
                            MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_APPROVED
                          ) {
                            setDeleteSectionIndex(index);
                          } else handleDeleteCard(index);
                        }}
                        sectionTitle={item.sectionTitle}
                        onChangeSectionTitle={(value: string) =>
                          changeSectionTitle(index, value)
                        }
                        onSectionTitleEditDone={async () => {
                          await handleCreateFA({});
                        }}
                        chapterList={item.chapterInfo?.chapterTopicsInfo}
                        noOfQuestions={getTotalQuestionNumber(index)}
                        difficultyLevel={
                          item.avgDifficultyLevel ===
                          DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED
                            ? '-'
                            : getDifficultyLevelString(item.avgDifficultyLevel)
                        }
                        chooseLibraryHandler={() => handleChooseLibrary(item)}
                        createAssessmentHandler={() => createFlowStarter(item)}
                        assessmentStatus={item.multiSubjectSectionStatus}
                        dragHandleProps={draggableProvided.dragHandleProps}
                        published={false}
                      />
                    </Box>
                  )}
                </Draggable>
              ))}
              {droppableProvided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>

      {multiSubjectsPopup ? (
        <FASelectMultiSubjectsPopup
          open={multiSubjectsPopup}
          handleClose={() => setMultiSubjectsPopup(false)}
          onProceedClick={() => {
            setMultiSubjectsPopup(false);
            fetchAssessmentContent();
          }}
          sectionMetaInfo={fa_content?.multiSubjectSections}
        />
      ) : null}

      <ActionPopUpSingleButton
        open={omrQuestionLimitPopupOpen}
        handleClose={() => setOmrQuestionLimitPopupOpen(false)}
        fontSmall
        iconName="error_yellow2"
        popupText={OMR_MAX_QUESTIONS_LIMIT_MESSAGE}
        ctaHandler={() => setOmrQuestionLimitPopupOpen(false)}
        buttontext="OK"
        background="rgba(193, 248, 218, 1)"
      />

      <InstructionPopup
        open={addInstructionsPopup}
        handleClose={() => {
          setAddInstructionsPopup(false);
          setInstructions(
            fa_content?.assessment?.assessmentInstructions[0] ?? ''
          );
        }}
        instructions={instructions}
        onChange={(e: string | undefined) => {
          setInstructions(e || '');
        }}
        addInstructionHandler={async () => {
          await handleCreateFA({});
          setAddInstructionsPopup(false);
        }}
      />

      <ValidationPopup
        open={saveToLibraryPopup}
        handleClose={() => {
          setSaveToLibraryPopup(false);
          navigate(ASSESMENT_LIBRARY, {
            state: { saveToLibraryFromFADraft: true },
          });
          dispatch(
            setAssessmentLibraryFilter({
              assessmentType: {
                name: 'Formative',
                id: AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT,
              },
            })
          );
        }}
        okHandler={() => {
          setSaveToLibraryPopup(false);
          navigate(ASSESMENT_LIBRARY, {
            state: { saveToLibraryFromFADraft: true },
          });
          dispatch(
            setAssessmentLibraryFilter({
              assessmentType: {
                name: 'Formative',
                id: AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT,
              },
            })
          );
        }}
        iconname={'check-green'}
        text1={`Your assessment "${fa_content?.assessment?.assessmentTitle}" has been successfully saved to the Library.`}
        // text2={validationStatus?.message}
      />

      <EditWarningPopup
        open={deleteSectionIndex !== undefined}
        handleClose={() => setDeleteSectionIndex(undefined)}
        yesClickHandler={() => {
          deleteSectionIndex !== undefined &&
            handleDeleteCard(deleteSectionIndex);
          setDeleteSectionIndex(undefined);
        }}
        noClickHandler={() => setDeleteSectionIndex(undefined)}
        iconname="error_yellow2"
        text1={`Are you sure you want to delete this section?`}
        text2=""
      />

      <EditWarningPopup
        open={libraryDuplicateWarningPopup}
        handleClose={handleDuplicateLibraryImportNo}
        yesClickHandler={handleDuplicateLibraryImportYes}
        noClickHandler={handleDuplicateLibraryImportNo}
        iconname="error_yellow2"
        text1={`${
          libraryDuplicateQuestionIds.length === 1
            ? 'One question is'
            : 'Some questions are'
        } already present in other sections and will be removed.`}
        text2="Do you want to proceed?"
      />

      <ValidationPopup
        open={libraryAllDuplicateWarningPopup}
        handleClose={handleDuplicateLibraryImportNo}
        okHandler={handleDuplicateLibraryImportNo}
        iconname="error"
        text1={
          'All questions are already present in other sections. This assessment cannot be added.'
        }
      />
    </Box>
  );
};
